import React, { createContext, useContext } from 'react';

interface SidebarContextValue {
  openSidebar: () => void;
  isMobile: boolean;
}

export const SidebarContext = createContext<SidebarContextValue | null>(null);

export function useSidebar(): SidebarContextValue {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarContext.Provider');
  }
  return context;
}
